var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('img',{style:({ width: _vm.widthPercent + '%'}),attrs:{"src":_vm.assetUrl(_vm.imageUrl)}})]),_vm._v(" "),(_vm.caption)?_c('div',{staticClass:"image-caption"},[_vm._v("\n    "+_vm._s(_vm.caption)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }